import Loadable from '../../components/loadable';

const RemoveVerifiedPhoneNumberModal = Loadable({
  loader: () => import('../../pages/user_profile/remove_verified_phone_number_modal'),
  type: 'modal',
});

angular.module('gym').value('RemoveVerifiedPhoneNumberModal', RemoveVerifiedPhoneNumberModal);
